import { HTMLAttributes } from 'react';

export interface IconParkIconProps extends HTMLAttributes<SVGAElement> {
  /**
   * 类型：string
   * 说明：包含打包的图标id
   * */
  'icon-id'?: string;

  /**
   * 类型：string
   * 说明：包含打包的图标id
   * */
  name?: string;

  /**
   * 类型：string
   * 说明：表示所渲染的 svg 图形宽高，默认1em，有效值的格式参考svg元素的宽度/高度取值。如果图标比例非1:1，建议略过此值，直接设置width，height
   * */
  size?: string | number;

  /**
   * 类型：string
   * 说明：表示所渲染的svg图形宽度，默认1em，优先级高于size
   * */
  width?: string;

  /**
   * 类型：string
   * 说明：表示所渲染的svg图形高度，默认1em，优先级高于size
   */

  height?: string;

  /**
   * 类型：string
   *
   * 说明：表示所渲染的svg图形中需要变色区域的颜色。有效值的格式参考svg元素的stroke/fill 取值
   */
  color?: string;

  /**
   * 类型：string
   *
   * 说明： 表示所渲染的 svg 图形中需要变色区域的 stroke 颜色，优先级高于 color
   */
  stroke?: string;

  /**
   * 类型：string
   *
   * 说明：表示所渲染的 svg 图形中需要变色区域的 fill 颜色，优先级高于 color
   */
  fill?: string;

  /**
   * 类型：string
   *
   * 说明：表示是否将svg图标从右到左渲染(镜像)，默认为 false。与一般html标签一致，标签上存在 rtl 属性即认为 true，例如<iconpark-icon rtl="false" icon-id="xxx"></iconpark-icon> 图标也会从右到左渲染
   */
  rtl?: string;

  /**
   * 类型：boolean
   *
   * 说明：表示是否为 svg 添加旋转动画（旋转动画为无限循环），默认为false
   */
  spin?: boolean;

  /**
   * 类型：string
   *
   * 说明：className 样式
   * */
  className?: string;
}

export const Icon = ({ name, className, ...rest }: IconParkIconProps) => {
  return (
    // @ts-ignore
    <iconpark-icon
      name={name}
      class={`iconpark-icon ${className || ''}`}
      {...rest}
    />
  );
};
